import React, { useContext } from "react";
import LocalHospitalOutlinedIcon from "@mui/icons-material/LocalHospitalOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";

import { ConfiguracionContext } from "../../../../context/ConfiguracionContext";
import MaestroArchivo from "../../common/MaestroArchivo";

const columns = [
  { field: "id", header: "ID", width: "6rem" },
  { field: "nombre", header: "Apellido y Nombre" },
  { field: "domicilio", header: "Domicilio" },
  { field: "telefono", header: "Teléfono" },
  { field: "email", header: "Email" },
  { field: "mn", header: "Matrícula Nacional" },
  { field: "mp", header: "Matrícula Provincial" },
  { field: "numeroDocumento", header: "D.N.I." },
  { field: "cuit", header: "C.U.I.T./C.U.I.L." },
  { field: "habilitado", header: "Habilitado", type: "bool", width: "9rem" },
];

const fields = [
  { name: "nombre", label: "Apellido y Nombre", type: "text", required: true, md: 12 },
  { name: "domicilio", label: "Domicilio", type: "text", md: 12 },
  { name: "telefono", label: "Teléfono", type: "text", md: 4 },
  { name: "email", label: "Email", type: "text", md: 8 },
  { name: "mn", label: "Matrícula nacional", type: "text", md: 3 },
  { name: "mp", label: "Matrícula provincial", type: "text", md: 3 },
  { name: "numeroDocumento", label: "D.N.I.", type: "text", md: 3 },
  { name: "cuit", label: "C.U.I.T./C.U.I.L.", type: "text", md: 3 },
  { name: "valorGuardia", label: "Valor Guardia", type: "number", md: 3 },
  { name: "nocturno", label: "% Nocturno", type: "number", min: 0, max: 100, rangeMsg: "Error", md: 3 },
  { name: "sadofe", label: "% Sab. Dom. Fer.", type: "number", min: 0, max: 100, rangeMsg: "Error", md: 3 },
  { name: "presentismo", label: "Adicional Presentismo", type: "number", md: 3 },
  { name: "pediatrico", label: "Adicional Pediátrico", type: "number", md: 3 },
  { name: "habilitado", label: "Habilitado", type: "switch", md: 12 },
];

export default function Medicos() {
  const {
    medicos,
    obtenerMedicos,
    agregarMedico,
    actualizarMedico,
    enviarLinkRegistroMedico,
  } = useContext(ConfiguracionContext);

  const accionesFila = [
    {
      icon: <SendOutlinedIcon fontSize="small" />,
      tooltip: "Registro Médico",
      color: "error",
      mostrar: (row, { configuracion }) =>
        Boolean(configuracion && configuracion.institucionId && configuracion.whapi),
      onClick: (row, { mensajeAlerta }) => {
        if (!row.telefono) {
          mensajeAlerta("Médicos", "El médico no tiene cargado el celular !.", "error");
          return;
        }
        enviarLinkRegistroMedico({ id: row.id, telefono: row.telefono });
      },
    },
  ];

  return (
    <MaestroArchivo
      titulo="Médicos"
      entidad="médico"
      layout="Medicos"
      icono={<LocalHospitalOutlinedIcon />}
      items={medicos}
      columns={columns}
      fields={fields}
      accionesFila={accionesFila}
      anchoDialog="lg"
      nuevoDefault={{
        nombre: "",
        domicilio: "",
        telefono: "",
        email: "",
        mn: "",
        mp: "",
        numeroDocumento: "",
        cuit: "",
        valorGuardia: "",
        nocturno: "",
        sadofe: "",
        presentismo: "",
        pediatrico: "",
        habilitado: true,
      }}
      onObtener={() => obtenerMedicos({ todos: true })}
      onAgregar={(data) => agregarMedico({ medico: data })}
      onActualizar={(data) => actualizarMedico({ medico: data })}
    />
  );
}
